'use strict';

const ENTITY_REDIRECTS = require('../data/pdp-entity-redirects.json');

// Shared by static generators and the browser. Keep the existing full-length
// static slug convention: changing punctuation rules creates real URL aliases.
const PRESERVED_PRODUCT_PATHS = {
  'canada:prod_1749683751952_7y9tev7': '/country/canada/products/prod_1749683751952_7y9tev7/name/attitude-volume-and-shine-hair-shampoo-for-sensiti',
};

function getProductSlug(name) {
  return String(name || 'product')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'product';
}

function generateProductPath(market, productId, name, { ignoreEntityRedirects = false } = {}) {
  const country = String(market || 'canada').toLowerCase();
  const id = String(productId || '').trim();
  if (!id || /^(undefined|null|nan)$/i.test(id) || !/^[a-zA-Z0-9_-]+$/.test(id)) return null;
  // Client-side navigation must resolve the same duplicate entities as the
  // server's 301 policy. The audit opts out to enumerate original source URLs.
  if (!ignoreEntityRedirects && ENTITY_REDIRECTS[`${country}:${id}`]) {
    return ENTITY_REDIRECTS[`${country}:${id}`];
  }
  const preserved = PRESERVED_PRODUCT_PATHS[`${country}:${id}`];
  if (preserved) return preserved;
  const base = country === 'global' ? '/global' : `/country/${country}`;
  return `${base}/products/${id}${name ? `/name/${getProductSlug(name)}` : ''}`;
}

module.exports = { generateProductPath, getProductSlug, PRESERVED_PRODUCT_PATHS };
